import { styled, keyframes } from '@mui/material/styles';
import Box from '@mui/material/Box';

// Animation for show all cell
export const showAllOpenAnim = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.92);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

export const WebGalleryRoot = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '4fr 1fr 1fr',
  gridTemplateRows: '1fr 1fr',
  gap: theme.spacing(2),
  width: '100%',
  height: 384,
  marginBottom: theme.spacing(2.5),
  [theme.breakpoints.down('md')]: {
    height: 300,
    gridTemplateColumns: '2fr 1fr',
    gridTemplateRows: '1fr 1fr 1fr',
  },
  [theme.breakpoints.down('sm')]: {
    height: 200,
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'repeat(5, 1fr)',
    marginBottom: theme.spacing(2),
  },
}));

export const WebGalleryMainImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: 20,
  boxShadow: '0 4px 24px 0 rgba(0,0,0,0.10)',
  transition: 'all 0.4s',
  overflow: 'hidden',
  outline: 'none',
  '&:focus': {
    boxShadow: `0 0 0 3px ${theme.palette.primary.main}55`,
  },
  maxHeight: 384,
}));

export const WebGalleryGridItem = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: 12,
  cursor: 'pointer',
  transition: 'transform 0.3s, box-shadow 0.3s',
  outline: 'none',
  '&:hover, &:focus': {
    transform: 'scale(1.04)',
    zIndex: 1,
    boxShadow: `0 2px 12px 0 ${theme.palette.primary.main}22`,
  },
  maxHeight: 184,
}));

export const WebGalleryShowAll = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  borderRadius: 12,
  overflow: 'hidden',
  cursor: 'pointer',
  background: theme.palette.grey[200],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 2px 12px 0 rgba(0,0,0,0.10)',
  outline: 'none',
  '&.show-all-animate': {
    animation: `${showAllOpenAnim} 0.5s cubic-bezier(0.4,0,0.2,1)`,
  },
  '&:focus': {
    boxShadow: `0 0 0 3px ${theme.palette.primary.main}55`,
  },
}));

export const WebGalleryMask = styled(Box)(({ theme }) => ({
  position: 'absolute',
  inset: 0,
  background: 'rgba(0,0,0,0.45)',
  zIndex: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const WebGalleryCount = styled('span')(({ theme }) => ({
  color: '#fff',
  fontWeight: 700,
  fontSize: 22,
  zIndex: 3,
  textShadow: '0 2px 8px rgba(0,0,0,0.25)',
  letterSpacing: 1,
}));
